import countriesData from './countries.json';

const normalizeCountryCode = (code) => {
  if (!code) return '';
  return String(code).trim().toUpperCase();
};

const countryByCodeMap = new Map(
  countriesData.map((country) => [normalizeCountryCode(country.code), country])
);

const countrySearchMap = new Map(
  countriesData.map((country) => [
    normalizeCountryCode(country.code),
    {
      name: (country.name || '').toLowerCase(),
      code: (country.code || '').toLowerCase(),
      altSpelling: (country.alternatespelling || '').toLowerCase(),
    },
  ])
);

const countryOptions = countriesData.map((country) => ({
  value: normalizeCountryCode(country.code),
  label: country.name,
}));

export const getCountryByCode = (code) => {
  return countryByCodeMap.get(normalizeCountryCode(code)) || null;
};

export const getCountryNameByCode = (code, fallback = '') => {
  const country = getCountryByCode(code);
  return country?.name || fallback;
};

export const getCountryOptions = () => countryOptions;

export const filterCountriesBySearch = (search) => {
  if (!search || search.trim() === '') return countryOptions;

  const searchLower = search.toLowerCase().trim();

  return countryOptions.filter((option) => {
    const data = countrySearchMap.get(option.value);
    if (!data) return false;
    return (
      data.name.includes(searchLower) ||
      data.code.includes(searchLower) ||
      data.altSpelling.includes(searchLower)
    );
  });
};

export { normalizeCountryCode };
export { countriesData };
export default countriesData;
